import Vue from 'vue';
import Component from 'vue-class-component';
import { SECTION_TYPES } from '@/content/values/sections';
import {_HOMEWORKS_STORE, HOMEWORK_STATUS} from '@/homework/values/homeworks.values';
import { Mixins } from 'vue-property-decorator';
import { HomeworkPdfDraw } from '@/courses/mixins/homework-pdf-draw.mixin';
import { SEND_CURRENT_SHARED_TASK_EVENT } from '@/content/values/ed-presentation-mode.values';

@Component({})
export default class EdHomeworkFileObject extends Mixins(HomeworkPdfDraw) {

  get isPdf(): boolean {
    return (this.section.type == SECTION_TYPES.LESSON_PDF.code) ||
        (this.section.assetsInfo && this.section.assetsInfo[0].pdfUrl);
  }

  get pdfUrl() : string {
    return this.section.assetsInfo[0].pdfUrl || this.section.assetsInfo[0].url;
  }

  get documentHash() : string {
    if(this.section.type == SECTION_TYPES.LESSON_TEXT.code) {
      const hash = this.section.assetsInfo?.[0]?.hash ?? (this.section.text ? JSON.parse(this.section.text)?.asset ?? null : null);
      return hash;
    }
    return this.section.text;
  }

  get canSendResponse(): boolean {
    return typeof this.canResponse !== 'undefined'
        ? this.canResponse
        : this.section.status != HOMEWORK_STATUS.GRADED && this.section.status != HOMEWORK_STATUS.FINISHED;
  }

  mounted() {
    if(this.isPdf && this.canSendResponse){
      this.callPdf();
    }else{
      this.cancelLoading();
      if(this.isPublisher && this.isPresentationTeacherMode){
        this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.UPDATE_SELETED_BOARD_INFO, {});
        this.$edEventBus.$emit(SEND_CURRENT_SHARED_TASK_EVENT);
      }
    }
  }

}